import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PostulacionHome from "./pages/postulaciones/PostulacionHome";
import PostulacionList from "./pages/postulaciones/PostulacionList";
import PostulacionEdit from "./pages/postulaciones/PostulacionEdit";
import PostulacionHistory from "./pages/postulaciones/PostulacionHistory";
import ConcursosContainer from "./pages/common/ConcursosContainer";
import { ApmRoute } from "@elastic/apm-rum-react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const App = (props) => {
  const theme = React.useMemo(
    () =>
      createMuiTheme({
        palette: {
          primary: {
            main: "#004a93",
          },
          secondary: {
            main: "#d7084c",
          },
        },
      }),
    []
  );

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <ApmRoute path="/ListaConcursos" component={PostulacionList} />
          <ApmRoute path="/HistorialConcursos" component={PostulacionHistory} />
          <ApmRoute
            path="/Postulacion/:concursoPk"
            component={PostulacionHome}
          />
          <ApmRoute
            path="/EditarPostulacion/:uuid/"
            component={PostulacionEdit}
          />
          <ApmRoute path="/Postulacion" component={PostulacionList} />
          <ApmRoute path="/" component={PostulacionList} />
          <Route path="/Postulacion">
            <p>
              No se especificó a qué concurso postular. Use{" "}
              <code>/Postulacion/&lt;inserte pk del concurso aquí&gt;</code>
            </p>
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  );
};

export default App;
